import { render } from "./AdminCurrencies.vue?vue&type=template&id=05067825&scoped=true"
import script from "./AdminCurrencies.vue?vue&type=script&lang=js"
export * from "./AdminCurrencies.vue?vue&type=script&lang=js"

import "./AdminCurrencies.vue?vue&type=style&index=0&id=05067825&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05067825"]])

export default __exports__